module.exports = __webpack_public_path__ + "static/img/fuming.833250f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/pc/fuming.png
// module id = dw9b
// module chunks = 70